import React from 'react';

import FAQ from '../components/FAQ';
import FAQS from '../data/content/faq';

export default () => <FAQ title={"FAQ's"} faqs={FAQS} />;
